import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { environment } from '../../environments/environment';
import { InventoryState, reducer as inventoryReducer } from './inventory/inventory.reducers';
import { SessionState, reducer as sessionReducer } from './session/session.reducers';
import { AppState, reducer as appReducer } from './app/app.reducers';
import { SettingsState, reducer as settingsReducer } from './settings/settings.reducers';
import { settingsOptionsReducer, SettingsOptionsState } from './settings-options/settings-options.reducer';
import { HiveState, HiveReducer as hiveReducer } from './hive';
import { ApplicationsState, reducer as applicationsReducer } from './applications';
import { ApiaryState, ApiaryReducer as apiaryReducer } from './apiary';
import { LoggingState, LogsReducer as logsReducer } from './logs';
import { UserSettingsState, UserSettingsReducer as userSettingsReducer } from './user-settings';
import { LotsReducer as lotsReducer, LotsState } from './lots';
import { UserProfileState, reducer as userProfileReducer } from './user-profile';
import { NoteState, NoteReducer as noteReducer } from './notes/note.reducers';
import { DocumentsState, DocumentsReducer as documentsReducer } from './documents/documents.reducers';

export interface State {
  router: RouterReducerState;
  session: SessionState;
  inventory: InventoryState;
  app: AppState;
  settings: SettingsState;
  settingsOptions: SettingsOptionsState;
  apiary: ApiaryState;
  applications: ApplicationsState;
  hive: HiveState;
  logs: LoggingState;
  userSettings: UserSettingsState;
  lots: LotsState;

  userProfile: UserProfileState;
  note: NoteState;
  documents: DocumentsState;
}

export const reducers: ActionReducerMap<State> = {
  router: routerReducer,
  session: sessionReducer,
  inventory: inventoryReducer,
  app: appReducer,
  settings: settingsReducer,
  settingsOptions: settingsOptionsReducer,
  apiary: apiaryReducer,
  applications: applicationsReducer,
  hive: hiveReducer,
  logs: logsReducer,
  userSettings: userSettingsReducer,
  lots: lotsReducer,

  userProfile: userProfileReducer,
  note: noteReducer,
  documents: documentsReducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
